import React from "react";
import {animated} from "react-spring";
import * as PropTypes from "prop-types";
import ImageGallery from "react-image-gallery";

export class Gallery extends React.Component {
    render() {
        return <section id="gallery">

            <animated.div style={this.props.style} className="container">
                <div className="section-header">
                    <h2>Gallery</h2>
                    <p>Check our gallery from the recent events</p>
                </div>
            </animated.div>

            <animated.div style={this.props.style} className="container">
                <div className="row">
                    <ImageGallery
                        lazyLoad={true}
                        showThumbnails={false}
                        showFullscreenButton={false}
                        showPlayButton={false}
                        autoPlay={true}
                        items={this.props.images}
                    />
                </div>

            </animated.div>
        </section>;
    }
}

Gallery.propTypes = {style: PropTypes.any, images: PropTypes.array};